'use strict';

import './style.css';
import typeDirective from './type';

const MODULE_NAME = 'daupler.incidents.style.panels';

var app = angular.module(MODULE_NAME, [
]);
app.directive('incidentPanel', typeDirective);

export default MODULE_NAME;
